import { Request } from '../../types';

import {
  JobIdFromSourceParams,
  JobIdFromTextParams,
  JobIdResponse
} from './types';

export * from './types';

export const getJobIdFromUrl = (request: Request) => ({
  source,
  storyboard_type,
  ...restParams
}: JobIdFromSourceParams) =>
  request<JobIdResponse>({
    method: 'PUT',
    url: 'storyboard/url',
    data: {
      source,
      storyboard_type: storyboard_type || 'openai',
      ...restParams
    }
  });

export const getJobIdFromText = (request: Request) => ({
  text,
  storyboard_type,
  ...restParams
}: JobIdFromTextParams) =>
  request<JobIdResponse>({
    method: 'PUT',
    url: `storyboard/text`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      text,
      storyboard_type: storyboard_type || 'openai',
      ...restParams
    }
  });
